<article class="w-[360px]">
  <div class="border border-white/80 bg-white/10 shadow-sm overflow-hidden">
    <!-- Top: Cover image -->
    <div class="relative aspect-square overflow-hidden">
      <img
        [src]="data?.image?.fields?.file?.url"
        width="800"
        height="800"
        class="absolute inset-0 w-full h-full object-cover"
        alt=""
      />
    </div>

    <!-- Bottom: Date as Button -->
    <div class="border-t border-white/70">
      <jnguyen-button
        class="w-full"
        [button]="data?.button.fields"
      ></jnguyen-button>
    </div>
  </div>
</article>
